import { createHeader, createAlignedHeader, createBulletPoint, createSpacingLine } from './componentHelpers'

export const renderLeadershipSection = leadershipExperiences => {
  if (!leadershipExperiences || leadershipExperiences.length === 0) {
    return []
  }

  return [
    createHeader("LEADERSHIP EXPERIENCE"),
    ...leadershipExperiences
      .filter(experience => experience)
      .flatMap(experience => {
        const title = experience.title || "TITLE"
        const affiliation = experience.affiliation || "AFFILIATION"
        const bulletPoints = experience.bulletPoints || []
        const startDate= experience.startDate || "STARTDATE"
        const endDate = experience.endDate || "Present"

        return [
          createAlignedHeader(title, affiliation, startDate, endDate),
          ...bulletPoints.map(b => createBulletPoint(b)),
          createSpacingLine,
        ]
      }),
  ]
}
